import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';

interface InputLockIndicatorProps {
    showWhatsAppInactivityTemplateState: boolean;
    assignee: string;
    ownExtensionKey: string;
    onClickUnlock: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => void;
}

/**
 * Displays lock indicator or unlock button for external reply input
 * when the ticket is assigned to someone else or WhatsApp template is required
 */
const InputLockIndicator = ({
    showWhatsAppInactivityTemplateState,
    assignee,
    ownExtensionKey,
    onClickUnlock,
}: InputLockIndicatorProps) => {
    const { i18next } = useAppContext();

    // WhatsApp template required - show lock icon only
    if (showWhatsAppInactivityTemplateState) {
        return <Icon iconKey="lockOutlined" className="text-gray-500" />;
    }

    // Assigned to someone else - show unlock button
    if (assignee !== ownExtensionKey) {
        return (
            <IconButton
                tooltipLabel={i18next.t('tickets.input.unlock')}
                onClick={onClickUnlock}
                className="bg-gray-300"
            >
                <Icon iconKey="lockOpen" />
            </IconButton>
        );
    }

    return null;
};

export default InputLockIndicator;
